export default __webpack_public_path__ + "assets/images/297249cf824831fc7fe3cd4a0e9fa52b.png";